/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import i18n from "locales/i18n";
import dayjs from "dayjs";
import ReactToPrint, { useReactToPrint } from 'react-to-print';
import { useLocation } from "react-router-dom";

import { Button, Modal, CardContent, Table, TableCell, TableContainer, TableRow, TableHead, TableBody} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import StopIcon from '@mui/icons-material/Stop';

import { useEnumApi } from "contexts/EnumApiContext";
import { getMaintenanceTasksByQuery } from "components/axios/maintenanceAxios";
import { getAttentionObservationsByQuery } from "components/axios/equipmentAlertsAxios";
import { getMaintenanceCheckupItemsByQuery } from "components/axios/maintenanceCheckupItemsAxios";
import { getLatestDiagnosisResultChainsByEquipmentId, getLatestDiagnosisResultNoisesByEquipmentId, getLatestDiagnosisResultVbeltsByEquipmentId, getLatestDiagnosisResultVibrationsByEquipmentId, getLatestEquipmentTemperaturesByEquipmentId, getReportCountMtnTaskGroupByCategory4ByEquipmentIdByQuery, getReportCountMtnTaskGroupByEquipmentPartByEquipmentIdByQuery, getReportFindReplaceTargetTopNByEquipmentIdByQuery, getReportResultLifeEstimatesByQuery } from "components/axios/reportAxios";
import MainCard from 'components/MainCard';
import AvgLifeTime from "components/AvgLifeTime";
import CSVReaderGraph from "components/inner/chart/CSVReaderGraph";
import { getEquipmentPartsWithSensorPositionByQuery } from "components/axios/equipmentAxios";
import EquipmentPartSensorsReportGraphs from "components/inner/chart/EquipmentPartSensorsReportGraphs";
import { getColorClassNameByGrade, getVBeltLengthStatusByScore, getVBeltLengthStatusGradeByScore, getVBeltElongStatusByScore, getVBeltElongStatusGradeByScore, getVibrationRatingStatusByScore, numberComma, replaceString, reverseOrderString, useTitle, getBrowserTitle } from "data/data";
import MenuInfo from 'data/menu';

const ComprehensiveReportLayer = ({info, station, previewImage=process.env.PUBLIC_URL+"/img/sample.png"}) => {
    const { getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t } = useTranslation();
    const changeTitle = useTitle();
    const fullpath = useLocation().pathname;
    const monitoring = MenuInfo.CMMS;
    let currentMenu = monitoring.find(fullpath);
    if (!currentMenu) {
      currentMenu = MenuInfo.MANAGEMENT_MAINTENANCE_EQUIPMENT.find(fullpath);
    }
    if (!currentMenu) {
      currentMenu = MenuInfo.MANAGEMENT_MAINTENANCE_EQUIPMENT_TRACKING.find(fullpath);
    }
    if (!currentMenu) {
      currentMenu = MenuInfo.MANAGEMENT_MAINTENANCE_EQUIPMENT_OBSERVE.find(fullpath);
    }
    if (!currentMenu) {
      currentMenu = MenuInfo.MANAGEMENT_MAINTENANCE_HISTORY.find(fullpath);
    }

    const hostname = window.location.hostname;
    const [open, setOpen] = useState(false);
    const handleClose = () => {setOpen(false);changeTitle(getBrowserTitle(hostname));}

    const handleOpen = () => {
        setOpen(true);
        changeTitle(replaceString(currentMenu?.name)+"_"+replaceString(info?.name)+"-"+info?.equipmentNo+"_"+t('message.common.title.comprehensive.report'));
    }

    const today = new Date();
    const year = dayjs(today).format("YYYY");
    const [componentCounts, setComponentCounts] = useState([]);
    const [equipmentPartCounts, setEquipmentPartCounts] = useState([]);
    const [equipmentParts, setEquipmentParts] = useState([]);
    const [maintenanceTasks, setMaintenanceTasks] = useState([]);
    const [attentionObservations, setAttentionObservations] = useState([]);
    const [checkupItems, setCheckupItems] = useState(null);
    const [inspectionEquipmentParts, setInspectionEquipmentParts] = useState([]);
    const [diffDay, setDiffDay] = useState(0);

    const [vibrationRatings, setVibrationRatings] = useState(null);
    const [noises, setNoises] = useState(null);
    const [chains, setChains] = useState(null);
    const [vBelts, setVBelts] = useState(null);
    const [temperatures, setTemperatures] = useState(null);
    const [failurePredictions, setFailurePredictions] = useState(null);
    const [failurePredictionAlls, setFailurePredictionAlls] = useState(null);
    const [resultLifeEstimates, setResultLifeEstimates] = useState();

    const [gatewayQuery, setGatewayQuery] = useState(null);
    // const [sensors, setSensors] = useState(null);
    const [equipmentPartsWithSensorPosition, setEquipmentPartsWithSensorPosition] = useState([]);

    const [isPrinting, setIsPrinting] = useState(false);
    const printRef = useRef(null);
    const promiseResolveRef = useRef(null);

    useEffect(() => {
      if (isPrinting && promiseResolveRef.current) {
        promiseResolveRef.current();
      }
    }, [isPrinting]);

    const handlePrint = useReactToPrint({
      content: () => printRef.current,
      onBeforeGetContent: () => {
        return new Promise((resolve) => {
          promiseResolveRef.current = resolve;
          setIsPrinting(true);
        });
      },
      onAfterPrint: () => {
        // Reset the Promise resolve so we can print again
        promiseResolveRef.current = null;
        setIsPrinting(false);
      }
    });

    useEffect(()=>{
      if (info && info.gateways) {
        let gatewayQuery = '';
        info.gateways.map(e => gatewayQuery += "&gateway.id="+e.gateway.id);
        setGatewayQuery(gatewayQuery);
      }
    },[info])

    useEffect(()=>{
        if (info && open) {
          Promise.all([
            // 2. 유지보수통계(구성부별)0
            getReportCountMtnTaskGroupByCategory4ByEquipmentIdByQuery({equipmentId:info.id}).then((data)=>{
              if(data) {
                  if (data) {
                    if (data.length < 6) {
                      for (let i = data.length; i < 6; i++) {
                        data.push([null,'','']);
                      }
                    }
                  } else {
                    for (let i = 0; i < 6; i++) {
                      data.push([null,'','']);
                    }
                  }
                  setComponentCounts(data);
              } else {
                setComponentCounts([]);
              }
            }),
            // 2. 유지보수통계(자재별)1
            getReportCountMtnTaskGroupByEquipmentPartByEquipmentIdByQuery({equipmentId:info.id}).then((data)=>{
              if(data) {
                  setEquipmentParts(data);
                  let countDatas = [...data];
                  if (data) {
                    if (data.length < 6) {
                      for (let i = data.length; i < 6; i++) {
                        countDatas.push([null,'','']);
                      }
                    }
                  } else {
                    for (let i = 0; i < 6; i++) {
                      countDatas.push([null,'','']);
                    }
                  }
                  setEquipmentPartCounts(countDatas);
              } else {
                setEquipmentPartCounts([]);
                setEquipmentParts([]);
              }
            }),
            // 3. 유지보수일지2
            getMaintenanceTasksByQuery({"equipment.id":info.id,sort:"workingBgnAt,desc",size:5}).then((data)=>{
              if (data && data._embedded) {
                setMaintenanceTasks(data._embedded.maintenanceTasks);
              } else {
                setMaintenanceTasks([]);
              }
            }),
            // 4. 예방점검 필요부품 (동종설비 평균수명 임박부품 5개)3
            getReportFindReplaceTargetTopNByEquipmentIdByQuery({equipmentId:info.id}).then((data)=>{
              if (data && data.length > 0) {
                let parts = [];
                data.map(function(item, i) {
                  let basicLifeSpan = item.masterEquipmentPart.lifeSpanTime/30/24;
                  let lifeSpan = item.lifeSpanTime/30/24;
                  let extendPeriod = 0;
                  if (basicLifeSpan < lifeSpan) {
                    extendPeriod = (lifeSpan-basicLifeSpan);
                  }
                  let recommendTime = dayjs(new Date(item.instlAt)).add((item.masterEquipmentPart.lifeSpanTime/30/24), "M").valueOf();
                  let instlTime = (new Date(item.instlAt)).getTime();
                  let useLiftSpan = (today.getTime() - instlTime);
                  let rate = Math.round(((today.getTime() - instlTime)/(recommendTime - instlTime)) * 100);
                  parts.push({
                      id:item.id
                    , masterEquipmentPartEquipmentCtgrName:item.masterEquipmentPart.equipmentCtgr.name
                    , position:item.position
                    , masterEquipmentPartName : item.masterEquipmentPart.name
                    , rate : rate
                    , useLiftSpan : useLiftSpan
                    , masterEquipmentPartLifeSpan : basicLifeSpan
                    , expectReplaceYmd : dayjs(new Date(item.instlAt)).add(lifeSpan, "M").format("YYYY-MM-DD")
                    , extendPeriod : extendPeriod
                    , instlAt:item.instlAt
                    , masterEquipmentPartId:item.masterEquipmentPart.id
                  })
                })

                const expectReplaceYmd = ((parts && parts.length > 0) ? parts[0].expectReplaceYmd : dayjs(today).format("YYYY-MM-DD"));
                let diff = Math.abs((new Date(expectReplaceYmd).getTime() - new Date(today).getTime()));
                diff = Math.ceil(diff / (1000 * 60 * 60 * 24));
                setDiffDay(diff);
                setInspectionEquipmentParts(parts);
              } else {
                setDiffDay(0);
                setInspectionEquipmentParts([]);
              }
            }),
            // 5. 주의관찰 조치현황4
            getAttentionObservationsByQuery({"equipment.id":info.id, sort:"regYmd,desc", size:5}).then((data)=>{
              if (data && data._embedded) {
                setAttentionObservations(data._embedded.attentionObservations);
              } else {
                setAttentionObservations([]);
              }
            }),
            // 6. 유지관리점검표5
            getMaintenanceCheckupItemsByQuery({"equipmentCtgr.id":info.equipmentCtgr.parent.id, chkItemType:"M", size:50, sort:"chkCycle,asc"}).then((data) => {
              if (data && data._embedded) {
                const list = data._embedded.maintenanceCheckupItem;
                if (list) {
                  list.map(item => item.chkCycleNm = item.chkCycle && getEnumValueByEnumNameAndCode("CheckCycle", item.chkCycle) && getEnumValueByEnumNameAndCode("CheckCycle", item.chkCycle)[0].title)
                  setCheckupItems(list);
                } else {
                  setCheckupItems(null);
                }
              } else {
                setCheckupItems(null);
              }
            }),            
            // 9. 구성부위치(ISO기준 진동량 측정)6
            getLatestDiagnosisResultVibrationsByEquipmentId(info.id).then((data)=>{
              if (data) {
                data.forEach(function(item) {
                  const tempArray = [item.rank_shaft, item.rank_horizon, item.rank_vertical];
                  reverseOrderString(tempArray);
                  item.maxGrade = tempArray[0];
                })
                const results = data.reduce((acc, curr) => {
                  const position = curr.equipment_part?.position; // 안전하게 접근
                  if (!position) return acc; // position이 없으면 무시
                  if (acc[position]) acc[position].push(curr);
                  else acc[position] = [curr];

                  return acc;
                }, {});
                setVibrationRatings(Object.values(results));

                let dataCopy = [];
                let diagnosisCodes = [];
                data && data.map(function(item) {
                  diagnosisCodes = [];
                  if (item.shaft_diagnosis_codes && item.shaft_diagnosis_codes.length > 0) {
                    item.shaft_diagnosis_codes.map((code)=>{
                      if(code.code !== "255")
                        diagnosisCodes.push(code);
                    })
                  }
                  if (item.horizon_diagnosis_codes && item.horizon_diagnosis_codes.length > 0) {
                    item.horizon_diagnosis_codes.map((code)=>{
                      if(code.code !== "255")
                        diagnosisCodes.push(code);
                    })
                  }
                  if (item.vertical_diagnosis_codes && item.vertical_diagnosis_codes.length > 0) {
                    item.vertical_diagnosis_codes.map((code)=>{
                      if(code.code !== "255")
                        diagnosisCodes.push(code);
                    })
                  }
                  if (diagnosisCodes.length > 0) {
                    dataCopy.push({...item, diagnosisCodes : diagnosisCodes});
                  }
                })
                setFailurePredictionAlls(dataCopy);
                const results2 = dataCopy.reduce((acc, curr) => {
                  const position = curr.equipment_part?.position; // 안전하게 접근
                  if (!position) return acc; // position이 없으면 무시
                  if (acc[position]) acc[position].push(curr);
                  else acc[position] = [curr];
                  return acc;
                }, {});
                setFailurePredictions(Object.values(results2));
              } else {
                setVibrationRatings(null);
                setFailurePredictions(null);
                setFailurePredictionAlls(null);
              }
            }),
            // 9. 구성부위치(소음)7
            getLatestDiagnosisResultNoisesByEquipmentId(info.id).then((data)=>{
              if (data) {
                const results = data.reduce((acc, curr) => {
                  const position = curr.equipment_part?.position; // 안전하게 접근
                  if (!position) return acc; // position이 없으면 무시
                  if (acc[position]) acc[position].push(curr);
                  else acc[position] = [curr];

                  return acc;
                }, {});
                setNoises(Object.values(results));
              } else {
                setNoises(null);
              }
            }),
            // 9. 구성부위치(체인)8
            getLatestDiagnosisResultChainsByEquipmentId(info.id).then((data)=>{
              if (data) {
                const results = data.reduce((acc, curr) => {
                  const position = curr.equipment_part?.position; // 안전하게 접근
                  if (!position) return acc; // position이 없으면 무시
                  if (acc[position]) acc[position].push(curr);
                  else acc[position] = [curr];

                  return acc;
                }, {});
                setChains(Object.values(results));
              } else {
                setChains(null);
              }
            }),
            // 9. 구성부위치(V벨트)9
            getLatestDiagnosisResultVbeltsByEquipmentId(info.id).then((data)=>{
              if (data) {
                const results = data.reduce((acc, curr) => {
                  const position = curr.equipment_part?.position; // 안전하게 접근
                  if (!position) return acc; // position이 없으면 무시
                  if (acc[position]) acc[position].push(curr);
                  else acc[position] = [curr];

                  return acc;
                }, {});
                setVBelts(Object.values(results));
              } else {
                setVBelts(null);
              }
            }),
            // 9. 구성부위치(설비온도)10
            getLatestEquipmentTemperaturesByEquipmentId(info.id).then((data)=>{
              if (data) {
                const results = data.reduce((acc, curr) => {
                  const position = curr.equipment_part?.position; // 안전하게 접근
                  if (!position) return acc; // position이 없으면 무시
                  if (acc[position]) acc[position].push(curr);
                  else acc[position] = [curr];

                  return acc;
                }, {});
                setTemperatures(Object.values(results));
              } else {
                setTemperatures(null);
              }
            }),
            // 9. 구성부위치(고장예측 정보)
            // getReportFindLatestRVDByEquipmentIdByQuery({"equipmentId":info.id}).then((data)=>{
            //   if (data) {
            //     data && data.map(function(item) {
            //       if (item.diagnosisCodes && item.diagnosisCodes.length > 0) {
            //         for(let i = 0; i < item.diagnosisCodes.length; i++) {
            //           if (!item.diagnosisCodes[i].codeYn)  {
            //             item.diagnosisCodes.splice(i, 1);
            //             i--;
            //           }
            //         }
            //       }
            //     })

            //     setFailurePredictionAlls(data);

            //     let dataCopy = [];
            //     data && data.map(function(item) {
            //       if (item.diagnosisCodes && item.diagnosisCodes.length > 0 && item.diagnosisCodes[0].code != 255) {
            //         dataCopy.push(item);
            //       }
            //     })
                
            //     const results = dataCopy.reduce((acc, curr) => {
            //       const { position } = curr.equipmentPart;
            //       if (acc[position]) acc[position].push(curr);
            //       else acc[position] = [curr];
            //       return acc;
            //     }, {});
            //     setFailurePredictions(Object.values(results));
            //   } else {
            //     setFailurePredictions(null);
            //     setFailurePredictionAlls(null);
            //   }
            // }),
            // 붙임1.공조설비 잔여수명 그래프11
            getReportResultLifeEstimatesByQuery({"equipment.id":info.id, "sensor.instlYn":true,"equipmentPart.deletedYn":false}).then((data)=>{
              if (data && data._embedded) {
                  const list = data._embedded.resultLifeEstimates;
                  if (list && list.length > 0) {
                      setResultLifeEstimates(list);
                      return list;
                  }
              }
            }),
            // 붙임3.진동데이터 그래프를 위한 자재목록12
            // getEquipmentPartsEquipmentsByIdAndQuery(info.id, {existSensorYn: true}).then((data) => {
            getEquipmentPartsWithSensorPositionByQuery({"equipment.id" : info.id, "sensorPositions.sensorType" : "V", deletedYn : false}).then((data) => {
              if (data) {
                return data;
              } else {
                return null;
              }
           })
          ]).then((res)=>{
            // console.log(gatewayQuery)
            //  if (gatewayQuery && res[10] && res[10].length > 0) {
            if (res[12] && res[12].length > 0) {
              let partQuery = '';
              // console.log(res[10]);
              setEquipmentPartsWithSensorPosition(res[12]);
              // res[10].map(e => partQuery += "&equipmentPart.id="+e.id);
              // let param = "?equipmentPart.deletedYn=false&instlYn=true&sensorType=V&sort=latestCommedAt,desc"+gatewayQuery+partQuery;
              // getSensorsByQueryString(param).then((data)=>{
              //   if (data && data._embedded) {
              //     setSensors(data._embedded.sensors)
              //   } else {
              //     setSensors(null)
              //   }
              // })
             }
          })
        }
    },[open, info]);

    return (
        <>
        <Button variant="contained" onClick={handleOpen} style={{minWidth:"unset"}}>
          {t('message.common.title.comprehensive.report')}
        </Button>
      {info && 
      <>
        <Modal className="pop_box" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
           <MainCard style={{maxWidth:"1440px", width:"90%", height:"75vh", backgroundColor:"#fff"}} title="" modal darkTitle content={false} className="print_box">
            <CardContent style={{height:"100%"}}>
              <div className='pop_close'>
                  <div style={{marginRight:"5px"}} className='no-print-page'><Button variant="contained" onClick={handlePrint}>{t('message.common.btn.print')}</Button></div>
                <Button color="primary" size="small" onClick={handleClose}>
                  {t('message.common.btn.close')}
                </Button>
              </div>
  
              <div style={{color:"#000"}} className="report_all" ref={ printRef }>
                <div className="report_page">
                  <div style={{width: "100%", backgroundColor:"#353535", color:"#fff", padding:"15px 0"}}>
                    <div style={{fontSize:"22px",textAlign: "center"}}>
                      {t('message.common.title.aiot.equipment.smart.management.system')} <br />
                      <span style={{fontSize:"26px"}}>{t('message.common.title.comprehensive.analysis.report')}</span>
                    </div>

                    <div style={{fontSize:"16px", color:"#fff", textAlign:"right", paddingRight:"20px"}}>({dayjs(new Date()).format("YYYY-MM-DD HH:mm")})</div>
                  </div>

                  <div>
                    <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                      1.&nbsp;{t('message.common.subtitle.equipment.specification')} / {t('message.common.subtitle.maintenance.department')}
                    </p>
                    <div className="report_box1">
                      <img style={{width:"100%"}} src={previewImage} alt="" />
                      <div className="report_cont1 report_cont11">
                        <TableContainer>
                          <Table sx={{ maxWidth: 980 }} aria-label="simple table">
                            <colgroup>
                              <col width="150px" />
                              <col width="*" />
                              <col width="150px" />
                              <col width="*" />
                            </colgroup>
                            <TableBody>
                              <TableRow>
                                <TableCell className="th" align="center" style={{color:"#000"}}>{t('message.common.subtitle.equipment.level1')}</TableCell>
                                <TableCell className="td" align="center">{info.equipmentCtgr.parent.parent.name}</TableCell>
                                <TableCell className="th" align="center" style={{color:"#000"}}>{t('message.common.subtitle.status')}</TableCell>
                                <TableCell className="td" align="center">{info.opStatus && getEnumValueByEnumNameAndCode("EquipmentOpStatus", info?.opStatus) && getEnumValueByEnumNameAndCode("EquipmentOpStatus", info?.opStatus)[0].title}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell className="th" align="center" style={{color:"#000"}}>{t('message.common.subtitle.equipment.level3')}</TableCell>
                                <TableCell className="td" align="center">{info.equipmentCtgr.name}</TableCell>
                                <TableCell className="th" align="center" style={{color:"#000"}}>{t('message.common.subtitle.position')}</TableCell>
                                <TableCell className="td" align="center">{info.location}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell className="th" align="center" style={{color:"#000"}}>{t('message.common.subtitle.equipment.name')}</TableCell>
                                <TableCell className="td" align="center">{info.name}</TableCell>
                                <TableCell className="th" align="center" style={{color:"#000"}}>{t('message.common.subtitle.mfCpnyNm')}</TableCell>
                                <TableCell className="td" align="center">{info.mfCpnyNm}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell className="th" align="center" style={{color:"#000"}}>{t('message.common.subtitle.equipment.number')}</TableCell>
                                <TableCell className="td" align="center">{info.equipmentNo}</TableCell>
                                <TableCell className="th" align="center" style={{color:"#000"}}>{t('message.common.subtitle.madeYmd')}</TableCell>
                                <TableCell className="td" align="center">{info.madeYmd}</TableCell>
                              </TableRow>
                              {/* <TableRow>
                                <TableCell className="th" align="center" style={{color:"#000"}}>{t('message.common.subtitle.management.department')}</TableCell>
                                <TableCell className="td" align="center">{station.workingPart.name}</TableCell>
                                <TableCell className="th" align="center" style={{color:"#000"}}>{t('message.common.subtitle.station.mngrNm')}</TableCell>
                                <TableCell className="td" align="center">{station.mngrNm}</TableCell>
                              </TableRow> */}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="report_page">
                  <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                    2.&nbsp;{t('message.common.title.maintenance.statistics')} ({dayjs(today).format("YY")}{t('message.common.title.year.current')} {t('message.common.title.standard')}) 
                  </p>
                  <TableContainer>
                    <Table sx={{ minWidth: 700 }} aria-label="simple table" className="same_width">
                      <TableBody>
                          <TableRow>
                            <TableCell className="td" align="center" style={{fontWeight:"bold"}} rowSpan={2}>
                              {t('message.common.file.name.component.part')}
                            </TableCell>
                            {componentCounts && componentCounts.map(function(component, i) {
                              return (
                                <TableCell key={i} className="th" align="center">{component[1]}</TableCell>    
                              )
                            })}
                          </TableRow>
                          <TableRow>
                            {componentCounts && componentCounts.map(function(component, i) {
                              return (
                                <TableCell key={i} className="td" align="center">{numberComma(component[2])}</TableCell>    
                              )
                            })}
                          </TableRow>
                          <TableRow>
                            <TableCell className="td" align="center" style={{fontWeight:"bold"}} rowSpan={2}>
                              {t('message.common.file.name.material')}
                            </TableCell>
                            {equipmentPartCounts && equipmentPartCounts.map(function(component, i) {
                              return (
                                <TableCell key={i} className="th" align="center">{component[1]}</TableCell>    
                              )
                            })}
                          </TableRow>
                          <TableRow>
                            {equipmentPartCounts && equipmentPartCounts.map(function(component, i) {
                              return (
                                <TableCell key={i} className="td" align="center">{numberComma(component[2])}</TableCell>    
                              )
                            })}
                          </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>

                <div className="report_page">
                  <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                    3.&nbsp;{t('message.common.subtitle.maintenance.log')}
                  </p>
                  <TableContainer>
                    <Table sx={{ minWidth: 700 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.maintenance.workingBgnAt')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.work.classification')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.work.detail')}</TableCell>                    
                          <TableCell className="th" align="center">{t('message.common.subtitle.worker')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.work.status')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {maintenanceTasks && maintenanceTasks.map(function(item, i) {
                          return (
                          <TableRow key={i}>
                            <TableCell className="td" align="center">{dayjs(item.workingBgnAt).format("YYYY-MM-DD HH:mm")}</TableCell>
                            <TableCell className="td" align="center">
                              {item.type && getEnumValueByEnumNameAndCode("MaintenanceType",item.type)?.[0].title}
                            </TableCell>
                            <TableCell className="td" align="center">{item.remark}</TableCell>                    
                            <TableCell className="td" align="center">{item.worker}</TableCell>
                            <TableCell className="td" align="center">
                              {item.status && getEnumValueByEnumNameAndCode("MaintenanceStatus",item.status)?.[0].title}
                            </TableCell>
                          </TableRow>  
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>

                <div className="report_page">
                  <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                    4.&nbsp;{t('message.common.title.preventive.inspection.require.part.similar.equipment.average.lifespan')} 
                  </p>
                  <TableContainer>
                    <Table sx={{ minWidth: 700 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell className="th" align="center" style={{width:"20%"}}>{t('message.common.subtitle.level3')}</TableCell>
                          <TableCell className="th" align="center" style={{width:"12%"}}>{t('message.common.subtitle.position')}</TableCell>
                          <TableCell className="th" align="center" style={{width:"15%"}}>{t('message.common.subtitle.material.classification')}</TableCell>                    
                          <TableCell className="th" align="center" style={{width:"18%"}}>{t('message.common.chip.remain.lifespan')}</TableCell>
                          <TableCell className="th" align="center" style={{width:"10%"}}>{t('message.common.subtitle.peer.average')}</TableCell>
                          <TableCell className="th" align="center" style={{width:"10%"}}>{t('message.common.subtitle.expect.replacement.date')}</TableCell>
                          <TableCell className="th" align="center" style={{width:"15%"}}>{t('message.common.subtitle.extend.period')}<br/>({t('message.common.subtitle.average.lifespan')}+α)</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {inspectionEquipmentParts && inspectionEquipmentParts.map(function(part, idx) {
                            let colorClass = "";
                            if (part.rate > 100) {
                              colorClass = "red";
                            }
                            return (
                          <TableRow key={idx}>
                            <TableCell className="td" align="center">{part.masterEquipmentPartEquipmentCtgrName}</TableCell>
                            <TableCell className="td" align="center">{part.position}</TableCell>
                            <TableCell className="td" align="center">{part.masterEquipmentPartName}</TableCell>                    
                            <TableCell className="td" align="center">
                              <div style={{position:"relative"}}>
                                <div style={{color:"#FFF",float:"left",position:"absolute"}}>{parseInt(part.useLiftSpan/30/24/1000/60/60)}{t('message.common.text.month')}</div>
                                <div className="percent">
                                  <p style={{width:"180px"}}><span className={colorClass} style={{width:`${part.rate > 100 ? 100:part.rate}%`}}></span></p>
                                  <span className="percent_month">{part.masterEquipmentPartLifeSpan}{t('message.common.text.month')}</span>
                                </div>
                              </div>
                            </TableCell>
                            <TableCell className="td" align="center"><AvgLifeTime masterEquipmentPartId={part.masterEquipmentPartId} position={part.position} useLife={part.useLiftSpan}/></TableCell>
                            <TableCell className="td" align="center">{part.expectReplaceYmd}</TableCell>
                            <TableCell className="td" align="center">{part.extendPeriod > 0 ? part.extendPeriod+t('message.common.text.month'):""}</TableCell>
                          </TableRow>
                            )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>

                <div className="report_page">
                  <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                    5.&nbsp;{t('message.common.title.observe.action.status')}
                  </p>
                  <TableContainer>
                    <Table sx={{ minWidth: 700 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.observe.write.date')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.action.detail.inspector.opinion')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.worker')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {attentionObservations && attentionObservations.map(function(item, i) {
                          return (
                          <TableRow key={i}>
                            <TableCell className="td" align="center">{item.regYmd}</TableCell>
                            <TableCell className="td" align="center">{item.remark}</TableCell>
                            <TableCell className="td" align="center">{item.regUser}</TableCell>
                          </TableRow>  
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>

                <div className="report_page">
                  <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                    6.&nbsp;{t('message.common.title.maintenance.checklist')}
                  </p>
                  <TableContainer>
                    <Table sx={{ minWidth: 700 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.select.division')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.regular.item')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.work.detail')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.remark')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {checkupItems && checkupItems.map(function(item, i) {
                          return (
                          <TableRow key={i}>
                            <TableCell className="td" align="center">{item.chkCycleNm}</TableCell>
                            <TableCell className="td" align="center">{item.chkItemNm}</TableCell>
                            <TableCell className="td" align="center">{item.chkItemDtlNm}</TableCell>
                            <TableCell className="td" align="center"> </TableCell>
                          </TableRow>  
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>

                <div className="report_page">
                  <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                    7.&nbsp;{t('message.common.title.mechanical.equipment.smart.management.system.inspection.opinion')}
                  </p>

                  {i18n.language === 'ko' ?
                  <div className="blue_box">
                    <p style={{marginTop:"10px"}}>
                      {(equipmentParts && equipmentParts.length > 0) &&
                      <>
                      - {station.name} {info.location} ({info.equipmentNo}) (은)는 유지보수 품목 중 {(equipmentParts && equipmentParts.length > 0 && equipmentParts[0][1]) || ''}의 유지보수 빈도가 가장 높습니다.<br/>
                      {(equipmentParts && equipmentParts.length > 1) ? <>- {(equipmentParts && equipmentParts.length > 0 && equipmentParts[0][1]) || ''} 외에 {(equipmentParts && equipmentParts.length > 0 && equipmentParts[1][1]) || ''}의 순으로 유지보수 빈도가 높습니다.<br/></>:''}
                      </>
                      }
                      {(inspectionEquipmentParts && inspectionEquipmentParts.length > 0) &&
                      <>
                      - 예상교체일이 가장 빠른 교체품목은 {(inspectionEquipmentParts && inspectionEquipmentParts.length > 0 && inspectionEquipmentParts[0].masterEquipmentPartName) || ''}입니다.<br/>
                      - 금일 ({dayjs(today).format("YYYY-MM-DD")})로 부터 약 {numberComma(diffDay)}일 후({(inspectionEquipmentParts && inspectionEquipmentParts.length > 0 && inspectionEquipmentParts[0].expectReplaceYmd) || ''})에 교체작업을 수행해야 할 것으로 예상됩니다.<br/>
                      - {(inspectionEquipmentParts && inspectionEquipmentParts.length > 0 && inspectionEquipmentParts[0].masterEquipmentPartName) || ''} 의 순으로 예상교체일이 빠릅니다.<br/>
                      -  [ {station.name} {info.location} ({info.equipmentNo})의 {(inspectionEquipmentParts && inspectionEquipmentParts.length > 0 && inspectionEquipmentParts[0].masterEquipmentPartName) || ''} 상태의 주기적인 모니터링을 수행해주세요.]
                      </>
                      }
                    </p>
                  </div>
                  : i18n.language === 'zh' ?
                  <div className="blue_box">
                    <p style={{marginTop:"10px"}}>
                      {(equipmentParts && equipmentParts.length > 0) &&
                      <>
                      - {station.name} {info.location} ({info.equipmentNo}) 是维护项目中 {(equipmentParts && equipmentParts.length > 0 && equipmentParts[0][1]) || ''}的维护频率最高<br/>
                      {(equipmentParts && equipmentParts.length > 1) ? <>- 除了 {(equipmentParts && equipmentParts.length > 0 && equipmentParts[0][1]) || ''} 之外 {(equipmentParts && equipmentParts.length > 0 && equipmentParts[1][1]) || ''}的维护频率依次较高<br/></>:''}
                      </>
                      }
                      {(inspectionEquipmentParts && inspectionEquipmentParts.length > 0) &&
                      <>
                      - 预计更换日期最快的更换项目是 {(inspectionEquipmentParts && inspectionEquipmentParts.length > 0 && inspectionEquipmentParts[0].masterEquipmentPartName) || ''}<br/>
                      - 预计在今日 ({dayjs(today).format("YYYY-MM-DD")}) 起大约 {numberComma(diffDay)} 天后（预计更换日期：{(inspectionEquipmentParts && inspectionEquipmentParts.length > 0 && inspectionEquipmentParts[0].expectReplaceYmd) || ''}）进行更换作业。<br/>
                      - 预计更换日期最快的按顺序为 {(inspectionEquipmentParts && inspectionEquipmentParts.length > 0 && inspectionEquipmentParts[0].masterEquipmentPartName) || ''}<br/>
                      - [ 请定期监控 {station.name} {info.location} ({info.equipmentNo}) 的 {(inspectionEquipmentParts && inspectionEquipmentParts.length > 0 && inspectionEquipmentParts[0].masterEquipmentPartName) || ''} 状态。]
                      </>
                      }
                    </p>
                  </div>
                  :
                  <></>
                  }
                </div>
                <div className="report_page">
                  <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                    8.&nbsp;{t('message.common.title.maintenance.main.communication')}
                  </p>

                  <div className="blue_box">
                    <p style={{marginTop:"10px", whiteSpace:"pre-line"}}>
                      {info.remark}
                    </p>
                  </div>
                </div>

                {info.iotInstlYn &&
                <>
                <div className="report_page">
                  <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                    9.&nbsp;{t('message.common.title.aiot.predictive.maintenance.diagnosis.result')}
                  </p>

                  <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                    <CheckBoxOutlineBlankIcon />&nbsp;{t('message.common.title.iso.standard.vibration.measurement')}
                  </p>
                  <TableContainer>
                    <Table sx={{ minWidth: 700 }} aria-label="simple table" className="same_width">
                      <TableHead>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.position')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.select.component.part')}</TableCell>
                          <TableCell className="th" align="center" colSpan={2}>{t('message.common.subtitle.axis')}</TableCell>
                          <TableCell className="th" align="center" colSpan={2}>{t('message.common.subtitle.radius')}</TableCell>
                          <TableCell className="th" align="center" colSpan={2}>{t('message.common.subtitle.vertical')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.status')}</TableCell>
                          {/* <TableCell className="th" align="center">{t('message.common.subtitle.expect.lifespan')}</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                      {vibrationRatings && vibrationRatings.length > 0 && vibrationRatings.map(function(items, i) {
                        // console.log(items)
                        return (
                        <React.Fragment key={i}>
                            {items.map(function(item, j) {
                              return (
                          <TableRow key={j}>
                            {j===0 && <TableCell className="td" align="center" rowSpan={items.length}>{item.equipment_part?.position}</TableCell>}
                              <TableCell className="td" align="center">{item.equipment_part?.masterEquipmentPart?.equipmentCtgr?.name}</TableCell>
                              <TableCell className="td" align="center">{item.overall_shaft.toFixed(2)}</TableCell>
                              <TableCell className={`td${getColorClassNameByGrade(item.rank_shaft)}`} align="center">{item.rank_shaft}</TableCell>
                              <TableCell className="td" align="center">{item.overall_horizon.toFixed(2)}</TableCell>
                              <TableCell className={`td${getColorClassNameByGrade(item.rank_horizon)}`} align="center">{item.rank_horizon}</TableCell>
                              <TableCell className="td" align="center">{item.overall_vertical.toFixed(2)}</TableCell>
                              <TableCell className={`td${getColorClassNameByGrade(item.rank_vertical)}`} align="center">{item.rank_vertical}</TableCell>
                              <TableCell className={`td${getColorClassNameByGrade(item.maxGrade)}`} align="center">{getVibrationRatingStatusByScore(item.maxGrade)}</TableCell>
                              {/* <TableCell className="td" align="center">{item.remainLifeMonth}{t('message.common.text.month')}</TableCell> */}
                          </TableRow>  
                              )
                            })}
                        </React.Fragment>
                        )
                      })}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {noises && noises.length > 0 &&
                  <>
                  <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                    <CheckBoxOutlineBlankIcon />&nbsp;{t('message.common.select.noise')}
                  </p>
                  <TableContainer>
                    <Table sx={{ minWidth: 700 }} aria-label="simple table" className="same_width">
                      <TableHead>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.position')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.select.component.part')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.noise.rms')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.skewness')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.kurtosis')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.noise.issue')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {noises.map(function(items, i) {
                          return (
                            <React.Fragment key={i}>
                              {items.map(function(item, j) {
                                return (
                            <TableRow key={j}>
                              {j===0 && <TableCell className="td" align="center" rowSpan={items.length}>{item.equipment_part.position}</TableCell>}
                              <TableCell className="td" align="center">{item.equipment_part?.masterEquipmentPart?.equipmentCtgr?.name}</TableCell>
                              <TableCell className="td" align="center">{item.rms.toFixed(2)}</TableCell>
                              <TableCell className="td" align="center">{item.skew.toFixed(2)}</TableCell>
                              <TableCell className="td" align="center">{item.kurtosis.toFixed(2)}</TableCell>
                              <TableCell className="td" align="center">{item.abnormal_check}</TableCell>
                            </TableRow>  
                                )
                              })}
                          </React.Fragment>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  </>
                  }

                  {chains && chains.length > 0 &&
                  <>
                  <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                    <CheckBoxOutlineBlankIcon />&nbsp;{t('message.common.select.chain')}
                  </p>
                  <TableContainer>
                    <Table sx={{ minWidth: 700 }} aria-label="simple table" className="same_width">
                      <TableHead>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.position')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.select.component.part')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.elongation')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.length')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.twist')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {chains.map(function(items, i) {
                          return (
                            <React.Fragment key={i}>
                              {items.map(function(item, j) {
                                return (
                            <TableRow key={j}>
                              {j===0 && <TableCell className="td" align="center" rowSpan={items.length}>{item.equipment_part.position}</TableCell>}
                              <TableCell className="td" align="center">{item.equipment_part?.masterEquipmentPart?.equipmentCtgr?.name}</TableCell>
                              <TableCell className="td" align="center">{item.elongation.toFixed(2)}</TableCell>
                              {/* <TableCell className="td" align="center">{getVBeltElongStatusByScore(item.elongation)}</TableCell> */}
                              <TableCell className="td" align="center">{item.length.toFixed(2)}</TableCell>
                              {/* <TableCell className="td" align="center">{getVBeltLengthStatusByScore(item.length)}</TableCell> */}
                              <TableCell className="td" align="center">{item.twisted_yn}</TableCell>
                            </TableRow>  
                                )
                              })}
                          </React.Fragment>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  </>
                  }

                  {vBelts && vBelts.length > 0 &&
                  <>
                  <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                    <CheckBoxOutlineBlankIcon />&nbsp;{t('message.common.select.vbelt')}
                  </p>
                  <TableContainer>
                    <Table sx={{ minWidth: 700 }} aria-label="simple table" className="same_width">
                      <TableHead>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.position')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.select.component.part')}</TableCell>
                          <TableCell className="th" align="center" colSpan={2}>{t('message.common.subtitle.elongation')}</TableCell>
                          <TableCell className="th" align="center" colSpan={2}>{t('message.common.subtitle.length')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.belt.shake')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {vBelts.map(function(items, i) {
                          return (
                            <React.Fragment key={i}>
                              {items.map(function(item, j) {
                                return (
                            <TableRow key={j}>
                              {j===0 && <TableCell className="td" align="center" rowSpan={items.length}>{item.equipment_part.position}</TableCell>}
                              <TableCell className="td" align="center">{item.equipment_part?.masterEquipmentPart?.equipmentCtgr?.name}</TableCell>
                              <TableCell className="td" align="center">{item.elongation.toFixed(2)}</TableCell>
                              <TableCell className="td" align="center">{getVBeltElongStatusByScore(item.elongation)}</TableCell>
                              <TableCell className="td" align="center">{item.length.toFixed(2)}</TableCell>
                              <TableCell className="td" align="center">{getVBeltLengthStatusByScore(item.length)}</TableCell>
                              <TableCell className="td" align="center">{item.sagging_yn}</TableCell>
                            </TableRow>  
                                )
                              })}
                          </React.Fragment>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  </>
                  }

                  {temperatures && temperatures.length > 0 &&
                  <>
                  <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                    <CheckBoxOutlineBlankIcon />&nbsp;{t('message.common.select.equipment.temperature')}
                  </p>
                  <TableContainer>
                    <Table sx={{ minWidth: 700 }} aria-label="simple table" className="same_width">
                      <TableHead>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.position')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.select.component.part')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.select.equipment.temperature')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {temperatures.map(function(items, i) {
                          return (
                            <React.Fragment key={i}>
                              {items.map(function(item, j) {
                                return (
                            <TableRow key={j}>
                              {j===0 && <TableCell className="td" align="center" rowSpan={items.length}>{item.equipment_part.position}</TableCell>}
                              <TableCell className="td" align="center">{item.equipment_part?.masterEquipmentPart?.equipmentCtgr?.name}</TableCell>
                              <TableCell className="td" align="center">{item.temperature.toFixed(2)}</TableCell>
                            </TableRow>  
                                )
                              })}
                          </React.Fragment>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  </>
                  }

                  <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                    <CheckBoxOutlineBlankIcon />&nbsp;{t('message.common.title.failure.prediction.information')}
                  </p>
                  <TableContainer>
                    <Table sx={{ minWidth: 700 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.position')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.select.component.part')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.defect.name')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {failurePredictions && failurePredictions.length > 0 && failurePredictions.map(function(items, i) {
                          // console.log(items)
                          return (
                            <React.Fragment key={i}>
                              {items.map(function(item, j) {
                                return (
                            <TableRow key={j}>
                              {j===0 && <TableCell className="td" align="center" rowSpan={items.length}>{item.equipment_part.position}</TableCell>}
                              <TableCell className="td" align="center">{item.equipment_part.masterEquipmentPart.name}</TableCell>
                              <TableCell className="td">
                                {item.diagnosisCodes && item.diagnosisCodes.length > 0 && item.diagnosisCodes.map(function(code, k) {
                                    return (
                                    <div key={k}>{code.categoryNm} : {code.subCategoryNm}</div>
                                    )
                                })}
                              </TableCell>
                            </TableRow>  
                                )
                              })}
                          </React.Fragment>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>

                <div className="report_page">
                  <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                    10.&nbsp;{t('message.common.title.smart.management.system.ai.automatic.analysis.report')}
                  </p>

                  {i18n.language === 'ko' ?
                  <div className="blue_box">
                    <p style={{color:"blue", fontWeight:"bold"}}>[{t('message.common.subtitle.status.diagnosis.analysis.report')}]</p>
                    <p style={{marginTop:"10px"}}>
                      - {info.name}({info.location})<br/>
                      {vibrationRatings && vibrationRatings.length > 0 && vibrationRatings.map(function(items, i) {
                        return (
                        <div key={i}>
                            {items.map(function(item, j) {
                              return (
                                <div key={j}>&nbsp;&nbsp;{item.equipment_part?.position}의 {item.equipment_part?.masterEquipmentPart?.equipmentCtgr?.name}의 진동량은 축 방향 {item.overall_shaft.toFixed(2)}, 반경 방향 {item.overall_horizon.toFixed(2)}, 수직 방향 {item.overall_vertical.toFixed(2)}이고 상태판정 결과는 “{getVibrationRatingStatusByScore(item.maxGrade)}” 상태로 판단</div>
                              )
                            })}
                        </div>
                        )
                      })}
                    </p>
                    
                    {vBelts && vBelts.length > 0 &&
                    <>
                    <p style={{color:"blue", fontWeight:"bold"}}>[{t('message.common.subtitle.elongation.length.analysis.report')}]</p>
                    <p style={{marginTop:"10px"}}>
                      - {info.name}({info.location})<br/>
                      {vBelts.map(function(items, i) {
                          return (
                            <div key={i}>
                              {items.map(function(item, j) {
                                return (
                      <div key={j}>&nbsp;&nbsp;{item.equipment_part.position}-V벨트의 동력전달율은 {item.length.toFixed(2)}%이고 등급이 {getVBeltLengthStatusGradeByScore(item.length)}이므로 상태판정 결과는 “{getVBeltLengthStatusByScore(item.length)}” 상태
                      , 신율은 {item.elongation.toFixed(2)}%이고 등급이 {getVBeltElongStatusGradeByScore(item.elongation)}이므로 상태판정 결과는 “{getVBeltElongStatusByScore(item.elongation)}” 상태로 판단됩니다.</div>

                                )
                              })}
                            </div>
                          )
                        })}
                    </p>
                    </>
                    }

                    <p style={{color:"blue", fontWeight:"bold"}}>[{t('message.common.subtitle.failure.prediction.analysis.report')}]</p>
                    <p style={{marginTop:"10px"}}>
                      {failurePredictionAlls && failurePredictionAlls.length > 0 && failurePredictionAlls.map(function(item, i) {
                        // console.log(item)
                        if (item.diagnosisCodes && item.diagnosisCodes.length > 0 && item.diagnosisCodes[0].code != 255) {
                          return (
                          <div key={i}>
                            - {info.name}({info.location}) {item.equipment_part.position}-{item.equipment_part.masterEquipmentPart.name}는 아래와 같이 결함 원인이 발생하였습니다.<br/>
                            {item.diagnosisCodes && item.diagnosisCodes.length > 0 && item.diagnosisCodes.map(function(code, k) {
                                return (
                                <div key={k}>&nbsp;&nbsp;* {code.categoryNm} : {code.subCategoryNm}</div>
                                )
                            })}
                            - {t('message.common.text.detail.inspection.manual.refer')}
                          </div>
                          )
                        } else {
                          return (
                          <div>- {info.name}({info.location}) {item.equipment_part.position}-{item.equipment_part.masterEquipmentPart.name}는 결함이 없습니다.</div>
                          )
                        }
                      })}
                    </p>
                    
                    <p style={{color:"blue", fontWeight:"bold"}}>[{t('message.common.subtitle.life.prediction.analysis.report')}]</p>
                    <p style={{marginTop:"10px"}}>
                      {resultLifeEstimates && resultLifeEstimates.map(function(part, idx) {
                          return (
                      <div key={idx}>
                      - {part.equipmentPart.position}-{part.equipmentPart.masterEquipmentPart.name}({info.location} {part.equipmentPart.position}{/*({part.equipmentPart.masterEquipmentPart.name})*/})<br/>
                      <div>&nbsp;&nbsp;금월({dayjs(today).format('YYYY년 MM월')}) 로부터 {part.equipmentPart.position}-{part.equipmentPart.masterEquipmentPart.name} 예상수명은 {part.result}개월입니다.</div>
                      </div>
                          )
                      })}
                    </p>
                  </div>
                  : i18n.language === 'zh' ?
                  <div className="blue_box">
                    <p style={{color:"blue", fontWeight:"bold"}}>[{t('message.common.subtitle.status.diagnosis.analysis.report')}]</p>
                    <p style={{marginTop:"10px"}}>
                      - {info.name}({info.location})<br/>
                      {vibrationRatings && vibrationRatings.length > 0 && vibrationRatings.map(function(items, i) {
                        return (
                        <div key={i}>
                            {items.map(function(item, j) {
                              return (
                                <div key={j}>&nbsp;&nbsp;{item.equipment_part?.position} 的 {item.equipment_part?.masterEquipmentPart?.equipmentCtgr?.name} 的振动量为轴向 {item.overall_shaft.toFixed(3)}, 径向 {item.overall_horizon.toFixed(3)}, 纵向 {item.overall_vertical.toFixed(3)}，状态判定结果为 “{getVibrationRatingStatusByScore(item.maxGrade)}” 状态</div>
                              )
                            })}
                        </div>
                        )
                      })}
                    </p>
                    
                    {vBelts && vBelts.length > 0 &&
                    <>
                    <p style={{color:"blue", fontWeight:"bold"}}>[{t('message.common.subtitle.elongation.power.length.analysis.report')}]</p>
                    <p style={{marginTop:"10px"}}>
                      - {info.name}({info.location})<br/>
                      {vBelts.map(function(items, i) {
                          return (
                            <div key={i}>
                              {items.map(function(item, j) {
                                return (
                                  <div key={j}>&nbsp;&nbsp;{item.equipment_part.position}-V 皮带的动力传输率为 {item.length}%，等级为 {getVBeltLengthStatusGradeByScore(item.length)}，状态判定结果为 “{getVBeltLengthStatusByScore(item.length)}” 状态。伸长率为 {item.elongation}%，等级为 {getVBeltElongStatusGradeByScore(item.elongation)}，状态判定结果为 “{getVBeltElongStatusByScore(item.elongation)}” 状态。</div>

                                )
                              })}
                            </div>
                          )
                        })}
                    </p>
                    </>
                    }

                    <p style={{color:"blue", fontWeight:"bold"}}>[{t('message.common.subtitle.failure.prediction.analysis.report')}]</p>
                    <p style={{marginTop:"10px"}}>
                      {failurePredictionAlls && failurePredictionAlls.length > 0 && failurePredictionAlls.map(function(item, i) {
                        if (item.diagnosisCodes && item.diagnosisCodes.length > 0 && item.diagnosisCodes[0].code != 255) {
                          return (
                          <div key={i}>
                            - {info.name}({info.location}) {item.equipment_part.position}-{item.equipment_part.masterEquipmentPart.name} 发生了以下故障原因。<br/>
                            {item.diagnosisCodes && item.diagnosisCodes.length > 0 && item.diagnosisCodes.map(function(code, k) {
                                return (
                                <div key={k}>&nbsp;&nbsp;* {code.categoryNm} : {code.subCategoryNm}</div>
                                )
                            })}
                            - {t('message.common.text.detail.inspection.manual.refer')}
                          </div>
                          )
                        } else {
                          return (
                            <div>- {info.name}({info.location}) {item.equipment_part.position}-{item.equipment_part.masterEquipmentPart.name} 没有故障。</div>
                          )
                        }
                      })}
                    </p>
                    
                    <p style={{color:"blue", fontWeight:"bold"}}>[{t('message.common.subtitle.life.prediction.analysis.report')}]</p>
                    <p style={{marginTop:"10px"}}>
                      {resultLifeEstimates && resultLifeEstimates.map(function(part, idx) {
                          return (
                      <div key={idx}>
                      - {part.equipmentPart.position}-{part.equipmentPart.masterEquipmentPart.name}({info.location} {part.equipmentPart.position}{/*({part.equipmentPart.masterEquipmentPart.name})*/})<br/>
                      <div>&nbsp;&nbsp;本月({dayjs(today).format('YYYY年 MM月')}) 起 {part.equipmentPart.position}-{part.equipmentPart.masterEquipmentPart.name} 的预期寿命为 {part.result} 个月。</div>
                      </div>
                          )
                      })}
                    </p>
                  </div>
                  :
                  <></>
                  }
                </div>

                <div className="report_page">
                  <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                    【{t('message.common.subtitle.attached')}1.】&nbsp;{t('message.common.subtitle.remain.lifespan.graph')} 
                  </p>

                  {resultLifeEstimates && resultLifeEstimates.length > 0 && resultLifeEstimates.map(function(result, idx) {
                    if (result.equipmentPart && result.sensor) {
                      return (
                  <div key={idx} className="chart_area1">
                    <MainCard>
                      <p style={{margin:"10px 0 0 10px",color:"#000"}}>{result.equipmentPart.position} {result.equipmentPart.masterEquipmentPart.name}</p>
                      <CSVReaderGraph sensorId={result.equipmentPart.id+'_'+result.sensor.position} type="report" isPrinting={isPrinting} />
                    </MainCard>
                  </div>
                      )
                    }
                  })}
                </div>

                {failurePredictions && failurePredictions.length > 0 && 
                <div className="report_page">
                  <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                    【{t('message.common.subtitle.attached')}2.】&nbsp;{t('message.common.subtitle.failure.prediction.occurrence.information')}  
                  </p>

                  <TableContainer>
                    <Table sx={{ minWidth: 700 }} aria-label="simple table">
                    <colgroup>
                      <col width="600px" />
                      <col width="*" />
                    </colgroup>
                      <TableHead>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.defective.area')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.failure.prediction')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {failurePredictions && failurePredictions.length > 0 && failurePredictions.map(function(items, i) {
                            return (
                              <React.Fragment key={i}>
                            {items.map(function(codes, idx) {
                              return (
                                <React.Fragment key={idx}>
                              {codes.diagnosisCodes && codes.diagnosisCodes.length > 0 && codes.diagnosisCodes.map(function(code, k) {
                                  return (
                        <TableRow key={k}>
                          <TableCell className="td" align="center">
                            <img src={process.env.PUBLIC_URL+`/mp4/${code.code}.jpg`} alt={t('message.common.text.failure.image')} style={{width:"95%"}} />
                          </TableCell>
                          <TableCell className="td" align="center">
                            <div>
                              ({codes.equipment_part.position}-{codes.equipment_part.masterEquipmentPart.name}) {code.subCategoryNm} : {code.categoryNm} 
                            </div>
                          </TableCell>
                        </TableRow>  
                                  )
                              })}
                              </React.Fragment>
                              )
                            })}
                            </React.Fragment>)
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
                }

                <div className="report_page">
                  <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                    【{t('message.common.subtitle.attached')}3.】&nbsp;{t('message.common.subtitle.vibration.data.graph')}{/* (C/D 등급 대상)  */}
                  </p>

                  <TableContainer>
                    <Table sx={{ minWidth: 700 }} aria-label="simple table" style={{display: "table"}}>
                    <colgroup>
                      <col width="150px" />
                      <col width="*" />
                    </colgroup>
                      <TableHead>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.equipment.name')}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.vibration.rate')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                          {/* {sensors && sensors.map(function(item, idx) { */}
                          {/* {equipmentPartsWithSensorPosition && equipmentPartsWithSensorPosition.map(function(item, idx) { */}
                          {equipmentPartsWithSensorPosition && equipmentPartsWithSensorPosition.map(function(part, idx1) {
                            // console.log(part)
                            return (
                              <React.Fragment key={idx1}>
                              {part.sensorPositions && part.id && part.sensorPositions.length > 0 && part.sensorPositions.map(function(item, idx) {
                              // console.log(item)
                              return (
                                <EquipmentPartSensorsReportGraphs key={idx} equipment={info} equipmentPart={part} sensorPosition={item} isPrinting={isPrinting} />
                              )
                              })}
                              </React.Fragment>
                            )
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>

                <div className="report_page">
                  <p style={{margin:"25px 0 10px 0", fontSize:"18px"}}>
                    {t('message.common.title.appendix')}
                  </p>

                  <p style={{fontSize:"16px"}}>
                    <StopIcon fontSize="small" />
                    {t('message.common.title.rating.criteria.description')}
                  </p>

                  <p style={{marginTop:"10px", fontSize:"15px"}}>
                    <CheckIcon fontSize="small" /> {t('message.common.title.motor.blower.vibration.judgment.standard')}
                  </p>
                  <TableContainer>
                    <Table aria-label="simple table" className="same_width">
                      <TableHead>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.grade')}</TableCell>
                          <TableCell className="th" align="center">A</TableCell>
                          <TableCell className="th" align="center">B</TableCell>
                          <TableCell className="th" align="center">C</TableCell>
                          <TableCell className="th" align="center">D</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell className="td" align="center" style={{fontWeight:"bold"}}>{t('message.common.subtitle.evaluation.score')}</TableCell>
                          <TableCell className="td g_font" align="center">1.0</TableCell>
                          <TableCell className="td g_font" align="center">2.0</TableCell>
                          <TableCell className="td g_font" align="center">3.0</TableCell>
                          <TableCell className="td g_font" align="center">4.0</TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell className="td" align="center" rowSpan="2" style={{fontWeight:"bold"}}>{t('message.common.subtitle.condition.diagnosis.judgment.score')}</TableCell>
                          <TableCell className="td ble_font" align="center">{t('message.common.text.good')}</TableCell>
                          <TableCell className="td gre_font" align="center">{t('message.common.text.commonly')}</TableCell>
                          <TableCell className="td yel_font" align="center">{t('message.common.text.inadequate')}</TableCell>
                          <TableCell className="td ju_font" align="center">{t('message.common.text.error')}</TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell className="td ble_font" align="center">~1.5</TableCell>
                          <TableCell className="td gre_font" align="center">1.5~2.5</TableCell>
                          <TableCell className="td yel_font" align="center">2.5~3.5</TableCell>
                          <TableCell className="td ju_font" align="center">3.5~</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <p style={{marginTop:"10px", fontSize:"15px"}}>
                    <CheckIcon fontSize="small" /> {t('message.common.title.vbelt.elongation.condition.judgment.standard')}
                  </p>
                  <TableContainer>
                    <Table aria-label="simple table" className="same_width">
                      <TableHead>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.grade')}</TableCell>
                          <TableCell className="th" align="center">A</TableCell>
                          <TableCell className="th" align="center">B</TableCell>
                          <TableCell className="th" align="center">C</TableCell>
                          <TableCell className="th" align="center">D</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell className="td" align="center" style={{fontWeight:"bold"}}>{t('message.common.subtitle.evaluation.score')}</TableCell>
                          <TableCell className="td g_font" align="center">4.0</TableCell>
                          <TableCell className="td g_font" align="center">3.0</TableCell>
                          <TableCell className="td g_font" align="center">2.0</TableCell>
                          <TableCell className="td g_font" align="center">1.0</TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell className="td" align="center" rowSpan="2" style={{fontWeight:"bold"}}>{t('message.common.subtitle.condition.diagnosis.judgment.score')}</TableCell>
                          <TableCell className="td ble_font" align="center">{t('message.common.text.good')}</TableCell>
                          <TableCell className="td gre_font" align="center">{t('message.common.text.commonly')}</TableCell>
                          <TableCell className="td yel_font" align="center">{t('message.common.text.inadequate')}</TableCell>
                          <TableCell className="td ju_font" align="center">{t('message.common.text.error')}</TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell className="td ble_font" align="center">0.0~1.5%</TableCell>
                          <TableCell className="td gre_font" align="center">1.5~2.0%</TableCell>
                          <TableCell className="td yel_font" align="center">2.0~2.5%</TableCell>
                          <TableCell className="td ju_font" align="center">2.5~4.0%</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <p style={{marginTop:"10px", fontSize:"15px"}}>
                    <CheckIcon fontSize="small" /> {t('message.common.title.power.transmission.condition.judgment.standard')}
                  </p>
                  <TableContainer>
                    <Table aria-label="simple table" className="same_width">
                      <TableHead>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.grade')}</TableCell>
                          <TableCell className="th" align="center">A</TableCell>
                          <TableCell className="th" align="center">B</TableCell>
                          <TableCell className="th" align="center">C</TableCell>
                          <TableCell className="th" align="center">D</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell className="td" align="center" style={{fontWeight:"bold"}}>{t('message.common.subtitle.evaluation.score')}</TableCell>
                          <TableCell className="td g_font" align="center">4.0</TableCell>
                          <TableCell className="td g_font" align="center">3.0</TableCell>
                          <TableCell className="td g_font" align="center">2.0</TableCell>
                          <TableCell className="td g_font" align="center">1.0</TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell className="td" align="center" rowSpan="2" style={{fontWeight:"bold"}}>{t('message.common.subtitle.condition.diagnosis.judgment.score')}</TableCell>
                          <TableCell className="td ble_font" align="center">{t('message.common.text.good')}</TableCell>
                          <TableCell className="td gre_font" align="center">{t('message.common.text.commonly')}</TableCell>
                          <TableCell className="td yel_font" align="center">{t('message.common.text.inadequate')}</TableCell>
                          <TableCell className="td ju_font" align="center">{t('message.common.text.error')}</TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell className="td ble_font" align="center">100~90%</TableCell>
                          <TableCell className="td gre_font" align="center">90~85%</TableCell>
                          <TableCell className="td yel_font" align="center">85~80%</TableCell>
                          <TableCell className="td ju_font" align="center">80% 이하</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
                </>
                }
              </div>
            </CardContent>
  
          </MainCard>
        </Modal>
        </>
        }
      </>
    )
}

export default ComprehensiveReportLayer;